export const mixin = {
    created() {},
    methods: {
        // 头部导航
        onBack(name) {
            if (!name) {

                this.$router.go(-1)
            } else {
                this.$router.push(name)
            }

        },
        onMenu(name) {
            if (typeof name == 'boolean') {} else {
                this.$router.push(name)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/libs/mixin.js